import React from 'react';
import Routes from './Routes';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Routes />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'var(--background)',
            color: 'var(--foreground)',
            border: '1px solid var(--border)',
          },
        }}
      />
    </>
  );
}

export default App;
